/* MeltaMug theme script */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var dataEl = document.getElementById("mm-data");
  var D = {};
  try { D = JSON.parse(dataEl ? dataEl.textContent : "{}"); } catch (e) { D = {}; }
  var ROOT = (D.routes && D.routes.root) || "/";
  var CURRENCY = D.currency || "EUR";
  var fmt = function (cents) {
    try { return new Intl.NumberFormat("fr-FR", { style: "currency", currency: CURRENCY }).format((cents || 0) / 100); }
    catch (e) { return ((cents || 0) / 100).toFixed(2).replace(".", ",") + " €"; }
  };
  var ic = function (id) { return '<svg class="ic" aria-hidden="true"><use href="#i-' + id + '"/></svg>'; };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var variants = D.variants || [];
  var byId = {};
  variants.forEach(function (v) { byId[v.id] = v; });
  if (D.trio) byId[D.trio.id] = { id: D.trio.id, name: D.trio.title, price: D.trio.price, compare: D.trio.compare, image: D.trio.image, tone: D.trio.tone, line: "pack", isTrio: true };

  /* ---------------- API panier ---------------- */
  var cartState = null;
  function api(url, body) {
    var opts = body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } };
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || "Erreur"); err.data = j; throw err; } return j; });
    });
  }
  function getCart() { return api(ROOT + "cart.js").then(function (c) { cartState = c; renderCart(); updateCount(); return c; }); }
  function addItems(id, qty) {
    return api(ROOT + "cart/add.js", { items: [{ id: Number(id), quantity: qty || 1 }] }).then(getCart);
  }
  function changeLine(key, qty) {
    return api(ROOT + "cart/change.js", { id: key, quantity: qty }).then(function (c) { cartState = c; renderCart(); updateCount(); return c; });
  }
  function updateCount(bump) {
    var el = $("#cartCount"); if (!el || !cartState) return;
    el.textContent = cartState.item_count; el.setAttribute("data-n", cartState.item_count);
    if (bump) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
  }
  function confirmBtn(btn) {
    if (!btn || btn.classList.contains("is-done")) return;
    var html = btn.innerHTML;
    btn.classList.add("is-done");
    btn.innerHTML = btn.classList.contains("card__add") ? ic("check") : '<span class="btn__label">' + ic("check") + "Ajouté</span>";
    setTimeout(function () { btn.classList.remove("is-done"); btn.innerHTML = html; }, 1500);
  }
  function handleAdd(id, qty, btn, opts) {
    opts = opts || {};
    if (btn) btn.setAttribute("aria-busy", "true");
    return addItems(id, qty).then(function () {
      updateCount(true);
      if (btn) confirmBtn(btn);
      if (opts.checkout) { window.location.href = ROOT + "checkout"; return; }
      if (opts.open !== false) setTimeout(openDrawer, btn ? 380 : 0);
    }).catch(function (err) {
      var box = $("#pdpError");
      var msg = (err && err.data && err.data.description) || "Impossible d’ajouter ce produit pour le moment.";
      if (box) { box.textContent = msg; box.hidden = false; } else { window.alert(msg); }
    }).then(function () { if (btn) btn.removeAttribute("aria-busy"); });
  }

  /* ---------------- tiroir panier ---------------- */
  var region = "fr";
  try { region = localStorage.getItem("mm_region") || "fr"; } catch (e) {}
  function lineName(item) {
    return item.product_has_only_default_variant ? item.product_title : item.product_title + " " + (item.options_with_values && item.options_with_values[0] ? item.options_with_values[0].value : item.variant_title);
  }
  function renderCart() {
    var body = $("#drawerBody"), foot = $("#drawerFoot"), count = $("#drawerCount");
    if (!body || !cartState) return;
    var c = cartState;
    count.textContent = c.item_count ? "(" + c.item_count + ")" : "";
    if (!c.item_count) {
      body.innerHTML = '<div class="cart-empty"><span class="arch-ic">' + ic("flame") + '</span><h3>Votre panier est vide</h3><p>La soirée cosy commence par un mug.</p><a class="btn" href="' + ROOT + '#collection" data-close-all>Voir la collection</a></div>';
      foot.innerHTML = ""; foot.hidden = true; return;
    }
    foot.hidden = false;
    var hasTrio = D.trio && c.items.some(function (i) { return i.variant_id === D.trio.id; });
    var html = '<p class="ship-note">' + ic("truck") + "<span>" + (region === "fr" ? "Votre livraison en France est <b>offerte</b>." : "Livraison hors de France : <b>" + fmt(D.euShipping) + "</b>.") + "</span></p><ul class=\"lines\">";
    c.items.forEach(function (it) {
      var meta = byId[it.variant_id] || {};
      var img = meta.image || (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_240x$1$2") : "");
      html += '<li class="line"><a href="' + esc(it.url) + '" class="line__img' + (meta.isTrio || it.product_has_only_default_variant ? " is-cover" : "") + '" style="--tone:' + esc(meta.tone || "#EADBC6") + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="86" height="86" loading="lazy">' : "") + "</a>" +
        '<div><a href="' + esc(it.url) + '" class="line__name">' + esc(lineName(it)) + '</a><p class="line__meta">' + fmt(it.final_price) + "</p>" +
        '<div class="line__ctl"><div class="qty qty--sm" role="group" aria-label="Quantité"><button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Retirer un">' + ic("minus") + "</button><output>" + it.quantity + '</output><button type="button" data-line="' + esc(it.key) + '" data-q="' + Math.min(20, it.quantity + 1) + '" aria-label="Ajouter un">' + ic("plus") + '</button></div><button type="button" class="line__rm" data-line="' + esc(it.key) + '" data-q="0">Retirer</button></div></div>' +
        '<p class="line__price">' + fmt(it.final_line_price) + "</p></li>";
    });
    html += "</ul>";
    if (D.trio && !hasTrio) {
      html += '<div class="upsell">' + (D.trio.image ? '<img src="' + esc(D.trio.image) + '" alt="" width="70" height="70">' : "") + "<div><b>" + esc(D.trio.title.replace(" MeltaMug", "")) + "</b><span>Blanc, Rouge et Chocolat · " + fmt(D.trio.price) + '</span></div><button type="button" data-upsell="' + D.trio.id + '">Ajouter</button></div>';
    }
    body.innerHTML = html;
    if (region !== "fr") region = "world";
    var ship = region === "fr" ? 0 : D.euShipping;
    foot.innerHTML = '<div class="seg" role="group" aria-label="Estimation de livraison"><button type="button" data-region="fr" aria-pressed="' + (region === "fr") + '">France · offerte</button><button type="button" data-region="world" aria-pressed="' + (region === "world") + '">Autres pays · ' + fmt(D.euShipping) + "</button></div>" +
      '<div class="sum"><div class="sum__row"><span>Sous-total</span><span>' + fmt(c.total_price) + '</span></div><div class="sum__row"><span>Livraison ' + (region === "fr" ? "France" : "hors France") + "</span><span>" + (ship ? fmt(ship) : "Offerte") + '</span></div><div class="sum__row sum__total"><span>Total estimé</span><span>' + fmt(c.total_price + ship) + "</span></div></div>" +
      '<a class="btn btn--block" href="' + ROOT + 'checkout">Passer commande' + ic("arrow") + "</a>" +
      '<p class="proto-note">' + ic("lock") + "Frais définitifs calculés au paiement selon l’adresse.</p>";
  }
  var lastFocus = null;
  function lockScroll(on) { document.documentElement.style.overflow = on ? "hidden" : ""; }
  function openDrawer() {
    var d = $("#drawer"); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add("is-on"); d.setAttribute("aria-hidden", "false");
    $("#scrim").classList.add("is-on"); lockScroll(true);
    setTimeout(function () { var b = $("#drawer .icon-btn"); if (b) b.focus({ preventScroll: true }); }, 60);
    if (!cartState) getCart();
  }
  function closeAll() {
    ["#drawer", "#msheet", "#modal"].forEach(function (s) { var el = $(s); if (el) { el.classList.remove("is-on"); el.setAttribute("aria-hidden", "true"); } });
    var sc = $("#scrim"); if (sc) sc.classList.remove("is-on");
    lockScroll(false);
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------------- barre d’achat mobile ---------------- */
  var stickyVariant = null;
  function paintSticky(v) {
    if (!v) return; stickyVariant = v;
    var img = $("#stickyImg"), name = $("#stickyName"), price = $("#stickyPrice");
    if (!img) return;
    if (v.image) img.src = v.image;
    img.style.setProperty("--tone", v.tone || "#EADBC6");
    img.style.objectFit = v.isTrio ? "cover" : "contain";
    name.textContent = v.isTrio ? v.name : ((D.main && D.main.title) || "MeltaMug") + " " + v.name;
    price.innerHTML = fmt(v.price) + (D.showCompare && v.compare > v.price ? ' <s style="color:var(--cocoa-3);margin-left:4px">' + fmt(v.compare) + "</s>" : "");
  }
  function setupSticky(anchor, v) {
    var bar = $("#sticky"); if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    paintSticky(v);
    var btn = $("#stickyBtn");
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle("is-on", past);
      bar.setAttribute("aria-hidden", String(!past));
      btn.tabIndex = past ? 0 : -1;
    }).observe(anchor);
    btn.addEventListener("click", function () { if (stickyVariant) handleAdd(stickyVariant.id, currentQty(), btn); });
  }
  var currentQty = function () { return 1; };

  /* ---------------- hero : choix du modèle ---------------- */
  function setupHero() {
    var box = $("[data-buy-box]"); if (!box) return;
    var addBtn = $("[data-add-variant]", box);
    function select(id) {
      var v = byId[id]; if (!v) return;
      $$(".sw", box).forEach(function (s) { s.setAttribute("aria-checked", String(Number(s.dataset.variantId) === v.id)); });
      $("[data-price]", box).textContent = fmt(v.price);
      var cmp = $("[data-compare]", box);
      if (cmp) { if (D.showCompare && v.compare > v.price) { cmp.textContent = fmt(v.compare); cmp.hidden = false; } else { cmp.hidden = true; } }
      $("[data-variant-label]", box).innerHTML = "<b>" + esc(v.name) + "</b> · " + (v.line === "deco" ? esc(v.badge || "Édition déco") : "Classique");
      addBtn.setAttribute("data-add-variant", v.id);
      $("[data-btn-price]", box).textContent = fmt(v.price);
      addBtn.disabled = !v.available;
      paintSticky(v);
    }
    box.addEventListener("click", function (e) { var sw = e.target.closest(".sw"); if (sw) select(Number(sw.dataset.variantId)); });
    var first = $(".sw[aria-checked='true']", box);
    setupSticky(addBtn, byId[first ? Number(first.dataset.variantId) : (variants[0] && variants[0].id)]);
  }

  /* ---------------- fiche produit ---------------- */
  function setupPdp() {
    var root = $("[data-pdp]"); if (!root) return;
    var isMain = root.dataset.main === "true";
    var form = $("[data-product-form]", root);
    var input = $("[data-variant-input]", root);
    var qtyInput = $("[data-qty-input]", root);
    var qty = 1;
    currentQty = function () { return qty; };
    var track = $("#galSlides");
    function visibleSlides() { return track ? $$(".gal__slide", track).filter(function (s) { return !s.hidden; }) : []; }
    function paintGallery() {
      var slides = visibleSlides(), n = slides.length;
      var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      var cnt = $("#galCount"); if (cnt) cnt.textContent = Math.min(idx + 1, n) + " / " + n;
      var thumbs = $$(".gal__thumb", root).filter(function (t) { return !t.hidden; });
      thumbs.forEach(function (t, k) { t.setAttribute("aria-current", String(k === idx)); });
      var dots = $("#galDots");
      if (dots) { dots.innerHTML = slides.map(function (_, k) { return '<span class="' + (k === idx ? "on" : "") + '"></span>'; }).join(""); }
    }
    function galGo(i) { if (!track) return; var n = visibleSlides().length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? "auto" : "smooth" }); }
    if (track) {
      var raf = 0;
      track.addEventListener("scroll", function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paintGallery); }, { passive: true });
      paintGallery();
    }
    root.addEventListener("click", function (e) {
      var t = e.target.closest("button"); if (!t) return;
      if (t.hasAttribute("data-gal")) { galGo(Math.round(track.scrollLeft / track.clientWidth) + Number(t.getAttribute("data-gal"))); }
      if (t.hasAttribute("data-thumb")) { var thumbs = $$(".gal__thumb", root).filter(function (x) { return !x.hidden; }); galGo(thumbs.indexOf(t)); }
      if (t.hasAttribute("data-pqty")) {
        qty = Math.max(1, Math.min(20, qty + Number(t.getAttribute("data-pqty"))));
        $("#pdpQty").textContent = qty; if (qtyInput) qtyInput.value = qty;
        var v = byId[Number(input.value)]; var price = v ? v.price : null;
        if (price != null) $("#pdpTotal").textContent = fmt(price * qty);
      }
      if (t.classList.contains("opt") && isMain && t.dataset.variantId) { selectVariant(Number(t.dataset.variantId), true); }
    });
    function selectVariant(id, push) {
      var v = byId[id]; if (!v) return;
      input.value = v.id;
      $$(".opt[data-variant-id]", root).forEach(function (o) { o.setAttribute("aria-checked", String(Number(o.dataset.variantId) === v.id)); });
      var title = $("[data-title]", root); if (title) title.textContent = ((D.main && D.main.title) || "MeltaMug") + " " + v.name;
      var crumb = $("[data-crumb]", root); if (crumb) crumb.textContent = v.name;
      var desc = $("[data-desc]", root); if (desc && v.desc) desc.textContent = v.desc;
      var long = $("[data-desc-long]", root); if (long) long.innerHTML = v.desc ? "<p>" + esc(v.desc) + "</p>" : "";
      var ll = $("[data-line-label]", root);
      if (ll) ll.innerHTML = v.line === "deco" ? 'Édition déco <span class="label label--line">' + esc(v.badge) + "</span>" : "Collection Classique";
      $("[data-price]", root).textContent = fmt(v.price);
      var cmp = $("[data-compare]", root);
      if (cmp) { if (D.showCompare && v.compare > v.price) { cmp.textContent = fmt(v.compare); cmp.hidden = false; } else { cmp.hidden = true; } }
      $("#pdpTotal").textContent = fmt(v.price * qty);
      $$("button[type=submit], [data-buy-now]", root).forEach(function (b) { b.disabled = !v.available; });
      var gal = $("[data-gallery]", root); if (gal) gal.style.setProperty("--tone", v.tone || "#EADBC6");
      if (track) {
        $$(".gal__slide, .gal__thumb", root).forEach(function (s) { var tag = s.dataset.tag; s.hidden = !!tag && tag !== v.tag; });
        track.scrollLeft = 0; paintGallery();
      }
      paintSticky(v);
      if (push) { var url = new URL(window.location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url.toString()); }
    }
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var err = $("#pdpError"); if (err) err.hidden = true;
        handleAdd(Number(input.value), qty, form.querySelector("button[type=submit]"));
      });
      var buyNow = $("[data-buy-now]", root);
      if (buyNow) buyNow.addEventListener("click", function () { handleAdd(Number(input.value), qty, null, { checkout: true }); });
    }
    var anchor = $("[data-sticky-anchor]", root);
    var initial = byId[Number(input && input.value)];
    if (!initial && D.trio && input && Number(input.value) === D.trio.id) initial = byId[D.trio.id];
    if (anchor && initial) setupSticky(anchor, initial);
  }

  /* ---------------- bandeau défilant ---------------- */
  function setupMarquee() {
    $$("[data-mq]").forEach(function (track) {
      var group = $(".mq__group", track); if (!group || !group.children.length) return;
      var unit = group.innerHTML;
      var speed = Number(track.dataset.speed) || 34;
      var builtFor = 0;
      function build() {
        var need = Math.max(window.innerWidth, (window.screen && screen.width) || 0, 1280) + 160;
        if (builtFor && need <= builtFor) return;
        track.style.animation = "none";
        track.innerHTML = '<div class="mq__group">' + unit + "</div>";
        var g = track.firstElementChild, n = 1;
        while (g.getBoundingClientRect().width < need && n < 30) { g.insertAdjacentHTML("beforeend", unit); n++; }
        var w = Math.ceil(g.getBoundingClientRect().width);
        g.style.width = w + "px";
        var clone = g.cloneNode(true); clone.setAttribute("aria-hidden", "true");
        track.appendChild(clone);
        track.style.setProperty("--mq-dur", Math.max(20, w / speed).toFixed(2) + "s");
        void track.offsetWidth;
        track.style.animation = "";
        builtFor = need;
      }
      build();
      var t = 0;
      window.addEventListener("resize", function () { clearTimeout(t); t = setTimeout(build, 250); }, { passive: true });
    });
  }

  /* ---------------- révélations, en-tête, parallaxe ---------------- */
  function setupReveal() {
    if (reduce || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove("pre"); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -8% 0px" });
    $$(".rv").forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight * 0.92) { el.classList.add("pre"); io.observe(el); } });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var h = $("#hdr"); if (h) h.classList.toggle("is-scrolled", window.scrollY > 8);
      var mood = $(".mood__img");
      if (mood && !reduce) {
        var r = mood.parentElement.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          mood.style.transform = "translate3d(0," + (p * -6).toFixed(2) + "%,0)";
        }
      }
      ticking = false;
    });
  }

  /* ---------------- délégation globale ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("button, a"); if (!t) return;
    if (t.hasAttribute("data-add-variant") && t.tagName === "BUTTON") { e.preventDefault(); handleAdd(Number(t.getAttribute("data-add-variant")), 1, t); return; }
    if (t.hasAttribute("data-upsell")) { handleAdd(Number(t.getAttribute("data-upsell")), 1, null, { open: false }); return; }
    if (t.hasAttribute("data-line")) { changeLine(t.getAttribute("data-line"), Number(t.getAttribute("data-q"))); return; }
    if (t.hasAttribute("data-region")) { region = t.getAttribute("data-region"); try { localStorage.setItem("mm_region", region); } catch (err) {} renderCart(); return; }
    if (t.hasAttribute("data-cart-open")) { if (document.body.classList.contains("tpl-cart")) return; e.preventDefault(); openDrawer(); return; }
    if (t.hasAttribute("data-menu-open")) { lastFocus = t; var m = $("#msheet"); m.classList.add("is-on"); m.setAttribute("aria-hidden", "false"); lockScroll(true); return; }
    if (t.hasAttribute("data-acc")) {
      var item = t.closest(".acc__item"); var open = !item.classList.contains("is-open");
      item.classList.toggle("is-open", open); t.setAttribute("aria-expanded", String(open)); return;
    }
    if (t.hasAttribute("data-close-all")) { closeAll(); return; }
    if (t.tagName === "A" && t.closest("#msheet")) { closeAll(); }
  });
  var scrim = $("#scrim"); if (scrim) scrim.addEventListener("click", closeAll);
  var mscrim = $(".modal__scrim"); if (mscrim) mscrim.addEventListener("click", closeAll);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  window.addEventListener("scroll", onScroll, { passive: true });

  $$("video").forEach(function (v) { v.muted = true; if (reduce) { v.removeAttribute("autoplay"); v.pause(); } else { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
  setupMarquee();
  setupHero();
  setupPdp();
  setupReveal();
  onScroll();
  getCart().catch(function () {});
})();
